import { TextField } from "@mui/material";
import HxfTextfieldNumber from "../HxfTextfieldNumber/HxfTextfieldNumber";
import { IDefInput } from "../statePopups/defineInputsDataPopup/DefineInputsDataPopup";


interface IHxfGenericInput {
    iInput:IDefInput;
    onChange?:any;
    value?:any;
    hasError?:boolean;
}
const HxfGenericInput = (props: IHxfGenericInput) => {


      
        let hasError = props.hasError;

        let inputPropsData:any = {};
        if(props?.iInput?.typeInputTextMaxLength){
            inputPropsData.maxLength = props.iInput.typeInputTextMaxLength;
        }

        if(props.iInput.inputType == "TEXTFIELD_NUMERIC"){
            return (
                <HxfTextfieldNumber
              
                dataInputFieldAttributeValue={props?.iInput?.dataInputFieldAttributeValue}
                startAdornment={props?.iInput?.inputAdornment ? props?.iInput.inputAdornment : null}
                fullWidth={true} 
                centerInputText={true} error={hasError ? hasError : false} label={props?.iInput?.label}
                onChange={(evt:any) => {
         
                    if(props.onChange){
                        props.onChange(evt);
                    }

                }} value={props.value ?  props.value : ""}/> 
            )
        }
        return (
            <TextField
            multiline={props.iInput.typeTextInputMultiline}
            autoFocus={props.iInput.typeInputTextAutoFocus}
            helperText
            inputProps={{...inputPropsData}}
            fullWidth
            error={hasError}
            onChange={(evt:any) => {

                if(props.onChange){
                    props.onChange(evt);
                }

            }}
            value={
                props.value ? props.value : ""
            }
            label={props.iInput?.label}
            variant="outlined"
            
            
        />
        )
    
}

export default HxfGenericInput;